module.exports = __webpack_public_path__ + "media/images/common/arrow_1-e9abdb90dce54fc81340640d40f0f1d4.gif";